module.exports = __webpack_public_path__ + "fonts/fa-regular-400.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-regular-400.woff
// module id = 50
// module chunks = 0